/**
 * Put an item into a project / take it out (project scope slice 3), through
 * projectsStore's own `contains` links — so a team project still only takes
 * items of its own team, and a viewer still cannot write (both refused there).
 * Every change reloads the membership the filters read.
 *
 * `nodeId` is the graph node (`board:<id>`, `document:<id>`, `ssh_host:<id>` …);
 * `wireScope` is the item's own scope ('personal' or 'team:<id>').
 */
import { addToProject, removeFromProject } from '../graph/projectsStore';
import { getProjectScope } from './projectScopeStore';
import { refreshProjectScope } from './projectScopeLoader';
import { enqueueScopeJob } from './projectScopeJobs';

const reload = () => enqueueScopeJob(() => refreshProjectScope().catch(() => {}));

// Both wait for the membership reload, so a caller that renders right after
// (a new page opening its rename field) already sees the item in its project.
export async function addItemToProject(project, nodeId, wireScope = 'personal') {
  await addToProject(project, { id: nodeId, scope: wireScope });
  await reload();
}

export async function removeItemFromProject(project, nodeId) {
  await removeFromProject(project, nodeId);
  await reload();
}

/**
 * Owner decision 0.2: an item created while a project is active belongs to
 * it. Never throws (the item exists either way); returns whether it was added.
 */
export async function addNewItemToActiveProject(nodeId, wireScope = 'personal') {
  const { activeProject, status } = getProjectScope();
  if (status !== 'ready' || !activeProject) return false;
  try {
    await addItemToProject(activeProject, nodeId, wireScope);
    return true;
  } catch (err) {
    console.warn('[project-scope] could not add the new item to the project:', err);
    return false;
  }
}
